module.exports = __webpack_public_path__ + "img/loan_home.fc72a012.png";